module.exports = __webpack_public_path__ + "assets/column-3.a04aa3b9.svg";